import React, { useState, useEffect, useRef } from 'react';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
    StepConnector
} from '@mui/material';
import * as actions from '../actions/micustomeractions'
import { useDispatch, useSelector } from "react-redux";

import AppRegistrationIcon from '@mui/icons-material/AppRegistration'; // Icon for registration info
import { set, useForm } from "react-hook-form";
import * as constanst from '../constants'
import PopupMessage from './popupMessage';
import { styled } from '@mui/material/styles';
import * as appConstants from '../../../overrides/appconstants'
import BasicInfo from './BasicInfo';
import BasicMemberInfo from './BasicMemberInfo';
import MAFInfo from './MAFInfo';
import ProductSelection from './ProductSelection'
import PersonIcon from '@mui/icons-material/Person';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Payment from './Payment';

const MedicalInsuranceStepper = () => {
    const dispatch = useDispatch();
    const refTop = useRef(null);
    const scrollToTop = () => {
        refTop.current?.scrollIntoView({ behavior: 'smooth' });

    };

    const state = useSelector(state => state.miCustomerSharedReducer);
    const [quoteSteps, setQuoteSteps] = useState(state.HAADSteps);

    let activeStep = state.activeStep;
    let payment = state.payment;
    let basicEnqInfo = state.basicInfoNewEnq;
    let productId = state.productId;
    useEffect(() => {
        dispatch(actions.getMICustomerMasters());
        scrollToTop();
    }, []);
    useEffect(() => {

        scrollToTop();
    }, [activeStep]);
    useEffect(() => {
        if (!productId) {
            setQuoteSteps(state.HAADSteps);
        }
        else if (productId == appConstants.NE_BASIC_PRODUCT_ID || productId == appConstants.NE_BASIC_ESS_PRODUCT_ID) {
            setQuoteSteps(state.NeSteps);
        }
        else {
            setQuoteSteps(state.HAADSteps);
        }


    }, [productId]);


    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Box textAlign={'left'} padding={'0px'} >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <AppRegistrationIcon
                                style={{
                                    fontSize: '2rem',
                                    animation: 'pulse 2s infinite',
                                    color: '#1976d2',
                                }}
                            />
                            <Typography variant="h6" style={{ marginLeft: '8px', color: '#ff8a00' }}>
                                Main Information
                            </Typography>
                            <style>
                                {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
                            </style>
                        </div>
                        <BasicInfo />

                    </Box>
                );
            case 1:
                return (
                    <Box>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <PersonIcon
                                style={{
                                    fontSize: '2rem',
                                    animation: 'pulse 2s infinite',
                                    color: '#1976d2',
                                }}
                            />
                            <Typography variant="h6" style={{ marginLeft: '8px', color: '#ff8a00' }}>Member Info</Typography>

                            <style>
                                {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
                            </style>
                        </div>

                        <BasicMemberInfo />
                    </Box>
                );
            case 2:
                return (
                    <Box>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <EventNoteIcon
                                style={{
                                    fontSize: '2rem',
                                    animation: 'pulse 2s infinite',
                                    color: '#1976d2',
                                }}
                            />
                            <Typography variant="h6" style={{ marginLeft: '8px', color: '#ff8a00' }}>Plan Selection</Typography>

                            <style>
                                {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
                            </style>
                        </div>
                        <ProductSelection section={appConstants.SECTION_INDICATIVE_QUOTE} />
                    </Box>
                );
            case 3:
                return (
                    <Box>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <PersonIcon
                                style={{
                                    fontSize: '2rem',
                                    animation: 'pulse 2s infinite',
                                    color: '#1976d2',
                                }}
                            />
                            <Typography variant="h6" style={{ marginLeft: '8px', color: '#ff8a00' }}>Full Member Details</Typography>

                            <style>
                                {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
                            </style>
                        </div>

                        <MAFInfo />
                    </Box>
                );


            case 4:
                return (
                    <Box>
                        <Typography variant="h6" style={{ marginLeft: '8px', color: '#ff8a00' }}>
                            {!payment.paymentDone ? "Kyc & Payment" : "Members Details"}

                        </Typography>
                        <Payment />
                        {/* <Button variant="contained" component="label">
                            Upload File
                            <input hidden accept="image/*" type="file" />
                        </Button> */}
                    </Box>
                );
            case 4:
                return (
                    <Box>
                        <Typography variant="h6">Member Information</Typography>
                        <TextField fullWidth label="Member Name" margin="normal" />
                        <TextField fullWidth label="Relationship" margin="normal" />
                    </Box>
                );
            default:
                return 'Unknown step';
        }
    };


    return (
        <Box sx={{ width: '90%', margin: 'auto', padding: '20px' }}>
            <Stepper activeStep={state.activeStep} alternativeLabel connector={null}  >
                {quoteSteps.map((step, index) => (
                    < >
                        <Step key={step.label}>
                            {/* <StepLabel StepIconComponent={(props) => {
                            const Icon = step.icon;
                            return <Icon color={props.active ? 'primary' : 'disabled'} />;
                        }}  >{step.label}</StepLabel>   */}

                            <StepLabel
                                StepIconComponent={() => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: 60,
                                                height: 60,
                                                borderRadius: '50%',
                                                overflow: 'hidden',
                                                border: index === activeStep ? '3px solid #3f51b5' : '3px solid #ccc',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: index === activeStep ? '0px 0px 10px rgba(63, 81, 181, 0.5)' : 'none',
                                            }}
                                        >
                                            <img
                                                src={step.image}
                                                alt={step.label}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </div>
                                        <span
                                            style={{
                                                marginTop: 8,
                                                color: index === activeStep ? '#3f51b5' : 'gray',
                                                fontWeight: index === activeStep ? 'bold' : 'normal',
                                            }}
                                        >
                                            {step.label}
                                        </span>
                                    </div>
                                )}
                            >
                                {/* {step.label}  */}
                            </StepLabel>
                        </Step>

                    </ >
                ))}
            </Stepper>


            <Box sx={{ margin: '20px 0' }}>
                {state.activeStep === constanst.STEPS.length ? (
                    <>
                        <Typography variant="h5" gutterBottom>
                            All Steps Completed
                        </Typography>
                        {/* onClick={handleReset} */}
                        <Button variant="contained" color="primary" >
                            Reset
                        </Button>
                    </>
                ) : (
                    <>

                        {renderStepContent(state.activeStep)}


                    </>
                )}
            </Box>
        </Box>
    );
};

export default MedicalInsuranceStepper;
